'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LOG_FILTER_ACTIONS = undefined;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _configConstants = require('../../../config/configConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LOG_FILTER_ACTIONS = exports.LOG_FILTER_ACTIONS = Immutable.Map({
    'redux-form/CHANGE': _configConstants.DEBUG_LEVEL.FINE
});

// Logging constants


//////////////////
// WEBPACK FOOTER
// ./src/client/store/loggingConfig.js
// module id = 2053
// module chunks = 0